module.exports = __webpack_public_path__ + "static/sharedine-7e48339d893d974416fe181c843b8763.png";